import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Injectable()
export abstract class BaseComponent implements OnDestroy {
  protected subscription = new Subscription();

  ngOnDestroy(): void {
    this.ngOnDestroyInternal();
    this.subscription.unsubscribe();
  }

  protected abstract ngOnDestroyInternal(): void;
}
